var _circle, _circle2, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNavNext(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 53,
    viewBox: "0 0 53 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 26.5,
    cy: 26.5,
    r: 26.5,
    fill: "#12121F"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 26.5,
    cy: 26.5,
    r: 19,
    fill: "#080815",
    stroke: "url(#paint0_linear_77_61)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.875 27.2187C30.875 27.3865 30.8109 27.5545 30.6828 27.6827L24.1203 34.2452C23.8638 34.5016 23.4486 34.5016 23.1923 34.2452C22.9361 33.9887 22.9359 33.5735 23.1923 33.3172L29.2909 27.2187L23.1923 21.1202C22.9359 20.8637 22.9359 20.4485 23.1923 20.1922C23.4488 19.936 23.864 19.9358 24.1203 20.1922L30.6828 26.7547C30.8109 26.8829 30.875 27.0509 30.875 27.2187Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_77_61",
    x1: 26.5,
    y1: 7,
    x2: 26.5,
    y2: 46,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AF00FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#001EFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavNext);
export default __webpack_public_path__ + "static/media/nav-next.2989aef36a85f30332f68de6c02271e6.svg";
export { ForwardRef as ReactComponent };